import React from "react";
import { useField } from "formik";
import { Select, SelectOption } from "@justworkshr/milo-form";
import { SystemIcon } from "@justworkshr/milo-components";
import styles from "./EmployeeTable.module.css";
interface optionType {
  value: string;
  name: string;
  description: string;
}
interface ITableSelectInputProps {
  name: string;
  placeholder: string;
  options: any;
}

const TableSelectInput = ({
  ...props
}: ITableSelectInputProps): JSX.Element => {
  const { name, placeholder, options } = props;
  const [field, meta] = useField(props);
  return (
    <div>
      <Select data-testid={name} id={name} {...field}>
        <SelectOption value="" disabled>
          {placeholder}
        </SelectOption>
        {options &&
          options.map((option: optionType) => {
            return (
              <SelectOption key={option.value} value={option.value}>
                {option.description}
              </SelectOption>
            );
          })}
      </Select>
      {meta.touched && meta.error && (
        <span className={styles.fieldError}>
          <SystemIcon iconName="error" color="error" size="small" />
          {meta.error}
        </span>
      )}
    </div>
  );
};

export default TableSelectInput;
